import { l as r } from "../../lodash-lyheMOjd.mjs";
import { localStore as l, sessionStore as c } from "../utils/browser-storage/index.js";
import { cleanArrayPredicate as a } from "../utils/predicate.js";
const m = (e) => e.setSelected(!0), P = (e) => e.groupId ? e.children.map((t) => t == null ? void 0 : t.colId) : [e.colId], S = (e) => e.colId !== "COLUMN_SORT" && e.colId !== "GRID_ACTION", g = (e) => e.colId !== "COLUMN_SORT" && e.colId !== "GRID_ACTION", O = (e) => ({
  column: e.colId,
  width: e.width,
  visible: e.hide,
  flex: null
}), A = (e) => r.map(e, ({
  column: t,
  width: n,
  visible: i
}) => ({
  colId: t,
  width: n,
  hide: i
})), x = (e) => {
  var t, n;
  return ((n = (t = e.cellRendererParams) == null ? void 0 : t.columnCustom) == null ? void 0 : n.type) !== "DEFAULT";
}, E = (e) => !e.pinned, s = (e) => {
  if (e.groupId) {
    const t = e.children.map((n) => s(n)).filter(a);
    return {
      ...e,
      children: t
    };
  }
  return e.lockVisible ? null : e;
}, u = (e) => e.groupId ? e.children.flatMap((t) => u(t)) : [{
  hide: e.hide ?? e.initialHide,
  colId: e.colId,
  width: e.width ?? e.initialWidth
}], R = (e) => ({
  ...e,
  hide: !1
});
function f(e) {
  return r.zipObject(e, r.range(e.length));
}
const I = (e, t) => {
  const n = t[e.colId];
  if (n !== void 0)
    return n;
  if (e.children) {
    const i = r.find(r.flatMap(e.children, (d) => [d, ...r.flatMap(d.children || [], (o) => o)]), (d) => t[d.colId] !== void 0);
    if (i)
      return t[i.colId];
  }
};
function T(e, t) {
  const n = f(t);
  return r.sortBy(e, (i) => I(i, n));
}
function v(e, t) {
  return e === "LOCAL" ? l.getItem(t) : c.getItem(t);
}
function D(e, t) {
  return r.isEmpty(r.xorWith(e, t, r.isEqual));
}
function M(e) {
  return r.every(e, (t) => !!t.hide);
}
function b(e, t) {
  return r.isEqual(e, t);
}
export {
  A as columnStateTransformer,
  g as filterActionColsDefsPredicate,
  S as filterActionColsPredicate,
  x as filterDefaultColsPredicate,
  E as filterPinnedColumns,
  P as getColIdsPredicate,
  O as getCustomColumnParams,
  f as getOrderMapping,
  T as getSortColumns,
  v as getStoredState,
  b as handleIsOrderChange,
  M as handleIsVisibleChange,
  D as isColumnEqual,
  u as mapColumnStatePredicate,
  R as mapColumnStateResetPredicate,
  s as mapFilterLockColsPredicate,
  m as nodeSelectedPredicate
};
//# sourceMappingURL=predicate.js.map
